import { ReactNode } from 'react';

export type QuickObjectsById = Record<string, QuickEntity>;

export interface QuickEntity {
  id: string;
  type: string;
  isFavorite: boolean;
  icon: ReactNode;
}

export const enum SubParentTypes {
  NONE = 'none',
  DATE = 'date',
  TYPE = 'type',
}
